module.exports = __webpack_public_path__ + "static/img/3.703c72c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/3.png
// module id = CYQT
// module chunks = 1